export default __webpack_public_path__ + "2024 First-principles screening of metal–organic frameworks for entangled photon pair generation.pdf";